{
  "deselectedItem": "{item} nincs kijelölve.",
  "select": "Kijelölés",
  "selectedAll": "Az összes elem kijelölve.",
  "selectedCount": "{count, plural, =0 {Egy elem sincs kijelölve} one {# elem kijelölve} other {# elem kijelölve}}.",
  "selectedItem": "{item} kijelölve."
}
